<script setup>
import { userAuthState } from "@/@core/auth"
import SurveyTable from "@/views/survey/collection/SurveyTable.vue"
import { SurveyType } from "@/enums/survey/survey.type"
import { computed } from "vue"

definePage({
  meta: {
    name: "Survey Collection",

    // subject: "service_desk.menu",
    // action: "dashboard",
  },
})

const auth = userAuthState()

const isFilterDialog = ref(true)

const surveyTypes = await getEnumValue("SurveyTypes", true)

const selectedSurveyType = ref()
const selectedSurvey = ref()

const computedFilter = computed(() => {
  return {
    type: selectedSurveyType.value,
  }
})

const {
  isFetching: loadingSurveys,
  data: surveys,
  execute: fetchSurveys,
} = useApi(createUrl('/survey/surveys', {
  query: {
    search: computedFilter,
  },
}), {
  beforeFetch: ({ cancel }) => {
    if (!selectedSurveyType.value) cancel()
  },
  afterFetch: () => {
    selectedSurvey.value = null
  },
})

const filters = ref({})
</script>

<template>
  <VAlert
    border="start"
    border-color="primary"
    class="mb-6"
  >
    <div class="d-flex align-center justify-space-between">
      <div>
        Update the base filter to view another survey's report.
      </div>
      <VBtn
        color="primary"
        density="comfortable"
        @click="isFilterDialog = true"
      >
        Update Filter
      </VBtn>
    </div>
  </VAlert>

  <div
    v-if="filters.survey_id"
    class="d-flex flex-column gap-y-6"
  >
    <div class="d-flex gap-6">
      <!-- Filter -->
      <VCard class="flex-grow-1">
        <VCardText>
          Filter
        </VCardText>
      </VCard>
    
      <!-- Graph -->
      <VCard class="flex-grow-1">
        <VCardText>
          Graph
        </VCardText>
      </VCard>
    </div>

    <!-- Table -->
    <SurveyTable
      :filters="filters"
      :survey="selectedSurvey"
    />
  </div>

  <!-- Base Filter Dialog -->
  <VDialog
    v-model="isFilterDialog"
    max-width="400"
    persistent
    z-index="999"
  >
    <VCard>
      <VCardText>
        <div>
          <div class="text-h5">
            Survey Collection
          </div>
          <div class="text-body-2">
            Select survey to view the list of collection
          </div>
        </div>
      </VCardText>
      <VDivider />
      <VCardText class="d-flex flex-column gap-4">
        <AppSelect
          v-model="selectedSurveyType"
          :items="surveyTypes"
          :item-title="item => item.title"
          :item-value="item => item.value"
          label="Type"
          placeholder="Select Type"
          :required="true"
        />
        <AppSelect
          v-model="selectedSurvey"
          :items="surveys ?? []"
          :item-title="item => item.title"
          :item-value="item => item.id"
          label="Survey"
          placeholder="Select Survey"
          :disabled="!selectedSurveyType"
          :loading="loadingSurveys"
          :return-object="true"
          :required="true"
        />
        <VBtn
          class="mt-2"
          :disabled="!selectedSurvey"
          @click="() => {
            filters.survey_id = selectedSurvey.id
            isFilterDialog = false
          }"
        >
          View Recorders
        </VBtn>
      </VCardText>
    </VCard>
  </VDialog>
</template>
